import isEqual from 'react-fast-compare';
import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

// @ts-expect-error
import formatters from 'notebook/mediocre/formatted-text/formatters';
import * as CreateOps from 'notebook/notes/CreateOps';
import NoteConstants, {CidIdMap} from 'notebook/notes/NoteConstants';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {generateUniqueName} from 'notebook/util/GenerateUniqueName';
import {NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';

import {NoteFillInTextBox, ToNoteFillInTextBoxBase} from './constants/FillInTextBoxConstants';

export function hasUnsubmittedValues(textBox: NoteFillInTextBox): boolean {
  const pertinentFelds = ['text', 'formats'];
  for (const field of pertinentFelds) {
    if (
      !isEqual(
        textBox[field as keyof NoteFillInTextBox],
        textBox.lastFinalizedValue?.[field as keyof NoteFillInTextBox['lastFinalizedValue']]
      )
    ) {
      return true;
    }
  }
  return false;
}
export function prepareForStore(item: NoteFillInTextBox, cidIdMap: CidIdMap): void {
  addCid(item, 'note-fill-in-text-box', cidIdMap);
}

export function prepareForSave(item: NoteFillInTextBox, cidIdMap: CidIdMap): ToNoteFillInTextBoxBase {
  return {
    ...item,
    id: cidIdMap[item.cid] as string,
  };
}

export function makeTextBoxItem(names: Array<string>): Omit<NotePart, 'item'> & {item: NoteFillInTextBox} {
  const item: NoteFillInTextBox = {
    text: '',
    name: generateUniqueName(names, 'Text Box', {allowNoSuffix: true}),
    formats: formatters.defaultFormats(),
    provenanceUuid: uuidv4(),
    // for finalization equality checking
    cid: _.uniqueId('note-fill-in-text-box'),
    type: NoteLinkedObjectType.NOTE_FILL_IN_TEXT_BOX,
    lastFinalizedValue: null,
  };

  return {
    ...CreateOps.makeDefaultItem(NoteConstants.NOTE_LINKED_OBJECT),
    item,
  };
}
